import { isMobile } from 'react-device-detect';
import React from 'react'

const TopBar = (props) => {
    console.log("props.title="+props.title);
    return (
        <div id="component-topbar" className={props.className} style={{backgroundColor: props.color}}>
          { props.title &&
            <div className="bloc-titre-topbar-contenu">
                <div style={{ fontSize: isMobile ? '2.5vw' : '1vw' }}>{props.title.toUpperCase()}</div>
                <div className="ligne-topbar-contenu"/>
            </div>
          }
            {props.buttons}
        </div>
    )
}

export default TopBar;
